<template>
    
    <div>

                    <v-progress-linear
                        v-if="!modulesLoaded"
                        color="green"
                        indeterminate
                        rounded
                        height="2"
                    ></v-progress-linear>                            



        <loadSaveTemplate 
            @closeLST="openSaveTemplate = false" 
            :openModal="openSaveTemplate" 
            type="main"
            :templateToSave="getPage" 
            @loadTemplate="loadAllTemplate"/>
            <insertElement :openvisu="openInsertElement" 
            @closeModal="openInsertElement = false" 
            @add="(el) => {addElem({place:'top',elem:el})}" />

<v-row no-gutters v-if="mod" class="justify-center align-center">
    <v-col class="pa-1 ma-1 dashed text-center text-caption rounded" cols="2" @click="addElem({place:'top',elem:'row'})">
    <v-icon>mdi-plus</v-icon><br>Ajouter une ligne
    </v-col>
    <v-col class="pa-1 ma-1 dashed text-center text-caption rounded" cols="2" @click="openInsertElement = true">
    <v-icon>mdi-plus</v-icon><br>Ajouter un élément
    </v-col>
    <v-col class="pa-1 ma-1 dashed text-center text-caption rounded" cols="2" @click="openSaveTemplate = true">
    <v-icon>mdi-harddisk</v-icon><br>éléments Sauvegardés
    </v-col>
</v-row>

 <draggable v-if="modulesLoaded" @start="drag = true" @end="drag = false"  :class="[mod ? 'heightdiv list-group': ''] " v-bind="dragOptions" :list="getPage" handle=".handle" group="a">
        <!-- Cette clé suit l'objet : insérer une ligne avant ne recrée pas ses modules. -->
        <routing v-for="(rowitem,rowindex) in getPage" 
            :key="getPageNodeKey(rowitem)"
            :item="rowitem"
            :mod="mod"
            :page="page"
            :modal="modal"
            :modalKey="modalKey"
            :parent="rowindex" 
            :index="rowindex"
            :hook="hook"
            :form="form"
            :drag="drag"
            :customquerys="customquerys"
            :customparams="customparams"
            @addElem="addElem"
            @removeElem="removeElem"
            @changeElem="changeElem"
            @sendDatas="sendDatas"
            :datasSend="datasSend"
        />

        </draggable>
            <v-row no-gutters v-if="mod" class="justify-center align-center">
                <v-col class="pa-1 ma-1 dashed text-center text-caption red lighten-5 rounded" cols="2" @click="addElem({place:'bottom',elem:'row'})">
                    <v-icon>mdi-plus</v-icon><br>Ajouter une ligne
                </v-col>
            </v-row>
    

    </div>

</template>




<script>

import { getPageNodeKey } from './nodeKey'
import { canPreviewModule } from '@/components/chat/resources'

export default {
        name : 'constructPage',
        inject: { chatResourceEmbedded: { default: false } },
        // inModifField permet de savoir si on est dans le filtre de relationnel global (bool true) ou simplement dans une requete (bool false).//
        props:['pageTemplate','page','modal','form','hook','mod','datasSend','customquerys','customparams','modalKey'],

        components : {
            draggable: () => import('vuedraggable'),
            //routing: () => import('./Routing'),
            routing: () => import('./Routing'),
            loadSaveTemplate: () =>
            import ('../../../main/templates/page/Edit/loadAndSaveTemplate.vue'),
            insertElement: () =>
            import ("./insertElement"),
        },

        data: function() {
            return {
                openSaveTemplate :false,
                //récupère tous les templates et les conditions
                getPage : this.pageTemplate,
                //intègre le template actif
                activTemplate : [],

                allowMod : this.mod,

                row : {type:'row',class:'',style:'',content:[],visuelcond:[]},
                col : {type:'col',class:'',style:'',content:[],visuelcond:[]},
                drag : false,
                openInsertElement : false,
                modulesLoaded : false,
            }
        },

        computed: {
            dragOptions() {
                return {
                animation: 0,
                group: "description",
                disabled: false,
                //ghostClass: "ghost",
                
                };
            }
        },

        watch : {
            modulesLoaded(ready) { if (ready) this.$emit('ready') },
            mod(val) {
                this.allowMod = val
            },

           pageTemplate: {
                handler(val) {
                    this.getPage = val
                    if(!this.mod)this.loadModules()
                },
            deep: true,
            } 
        },

        methods : {

            // Identité locale utilisée uniquement par Vue, jamais ajoutée au JSON sauvegardé.
            getPageNodeKey,

            loadModules() {
                if(!this.getPage) {
                    this.modulesLoaded = true
                    return;
                }

                //on va vérifier que le template intègre des modules, dans ce cas on les charges et on affiche la page. sinon on affiche tout court.
                let extractModules = this.extractModules(this.getPage)
                if(this.chatResourceEmbedded) extractModules = extractModules.filter(item => canPreviewModule(item.component))
                if(!extractModules.length) {
                    this.modulesLoaded = true
                    return;
                }

                this.modulesLoaded = false
                
                const pageContext = this.$store.getters.specificPage(this.modalKey) || {}
                let params = pageContext.params
                if(this.customparams) params = this.customparams;
                let querys = JSON.parse(JSON.stringify(this.$route.query || {}));
                
                if(this.hook == 'search') querys['global'] = this.$store.getters.getStringSearch;

                this.API({type:'post', url:'getModulesDatas', params:{modules : extractModules, key:this.modalKey, params : params??{}, querys : querys }}).then((resp) => {
                    if(this._isBeingDestroyed || this._isDestroyed) return
                    if(resp.data.modules) this.$store.dispatch('insertModuleDatas', { page: this.modalKey, modules: resp.data.modules });
                    this.modulesLoaded = true
                }).catch(() => { this.modulesLoaded = true })

            },

            loadAllTemplate(temp) {
                if(confirm('Vous allez remplacer tout le contenu existant par celui importé, continuer ?')) {
                    this.getPage = temp; 
                    this.openSaveTemplate = false;
                    this.$emit('recepVal',this.getPage);
                }
            },

            addElem(p) {

                let elem = (!this[p.elem]) ? p.elem : this[p.elem];

                    if(p.place=='top') {
                        this.getPage.unshift(JSON.parse(JSON.stringify(elem)))
                        return; 
                    }
                    if(p.place=='bottom') {
                        this.getPage.push(JSON.parse(JSON.stringify(elem)))
                        return; 
                    }
                const deep = (p.place.toString().length < 3) ? [p.place] : p.place.split('-');
                var length = deep.length
                
                var ee = this.getPage;
                deep.forEach((v, i) => {
                if (i == length - 1) {
                    ee[v].content.push(JSON.parse(JSON.stringify(elem)))
                } else {
                    ee = ee[v]['content']
                }

                })

                this.$emit('recepVal',this.getPage);

            },

            removeElem(place) {
            const deep = (place.toString().length < 3) ? [place] : place.split('-');
            var length = deep.length

            var ee = this.getPage;
            
            deep.forEach((v, i) => {
                if (i == length - 1) {
                    ee.splice(v, 1)
                } else {
                    ee = ee[v]['content']
                }

            })

            this.$emit('recepVal',this.getPage);

            },

            changeElem(p) {
            const deep = (p.place.toString().length < 3) ? [p.place] : p.place.split('-');
            var length = deep.length  
            var ee = this.getPage;
                deep.forEach((v, i) => {

                    if (i == length - 1) {
                        ee = ee[v][p.key] = p.value
                    } else {
                        ee = ee[v]['content']
                    }

                })              
            this.$emit('recepVal',this.getPage);
            },

            sendDatas(p) {
                this.$emit('sendDatas',p);
            }

        },

        mounted() {
            this.loadModules()
        }
    }
</script>

<style>

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.dashed {
    border:2px rgb(212, 212, 212) dashed;
    opacity:0.8;
    cursor:pointer;
}
.dashed:hover {
    opacity:1;
}
.heightdiv {
    min-height:120px;
}

</style>
